import { Component } from "react";
import "./chartPie.css";
import c3 from "c3";
import * as d3 from "d3";
import PropTypes from "prop-types";
import "c3/c3.css";
import { Accordion, Button, Card, Row, Col } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";

function ContextAwareToggle({ children, eventKey, callback }) {
  const accordionOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );

  return (
    <Button type="button" variant="link" onClick={accordionOnClick}>
      {children}
    </Button>
  );
}

ContextAwareToggle.propTypes = {
  children: PropTypes.string,
  eventKey: PropTypes.string,
  callback: PropTypes.func,
};

// Although this is stateless, lifecycle was needed.
// So class based component was used instead of functional component.
export default class ChartPie extends Component {
  constructor(props) {
    super(props);

    this.updateDone = false;
    this.isIE = false;

    if (window.ActiveXObject || "ActiveXObject" in window) {
      this.isIE = true;
    }
  }

  componentDidMount() {
    if (this.props.allData.length > 0) {
      this.updateHitsPieChart();
      this.updateSizePieChart();
    } else {
      this.updateDone = false;
    }
  }

  updateHitsPieChart() {
    const self = this;
    let dataArray = [];
    dataArray = this.props.allData.map((data) => {
      return [data.Description, data.Hits];
    });

    let singleTheme = true;
    const firstTheme = dataArray[0][0];
    for (let i = 0; i < dataArray.length; i++) {
      if (dataArray[i][0] !== firstTheme) singleTheme = false;
    }

    if (singleTheme) {
      dataArray = this.props.allData.map((data) => {
        if (data.Dataset) {
          return [data.Dataset, data.Hits];
        } else if (data.Interface) {
          return [data.Interface, data.Hits];
        } else if (data.Description) {
          return [data.Description, data.Hits];
        } else {
          return null;
        }
      });
    }

    const resize = dataArray.length > 15;
    const chart1 = c3.generate({
      bindto: "#chartHitsSummaryByTheme",
      data: {
        type: "pie",
        columns: dataArray,
      },
      pie: {
        label: {
          format: function (value, ratio, id) {
            ratio = d3.format("%")(ratio); // format ratio
            if (self.isIE === true) {
              return id;
            } else {
              return [id, ratio].join(); // used to pass values to the onrender function
            }
          },
        },
      },
      onrendered: function () {
        if (window.ActiveXObject || "ActiveXObject" in window) {
          console.log("its IE");
          return;
        }

        d3.selectAll("#chartHitsSummaryByTheme .c3-chart-arc text").each(
          function (v) {
            const label = d3.select(this);
            const data = label._groups[0][0].innerHTML.split(",");
            if (!data[0].toString().includes("<tspan")) {
              const id = data[0];
              const perc = data[1];

              //http://jsfiddle.net/user2314737/kvz8uev8/2/
              const width = 214;
              const radius = width / 2;
              const newarc = d3
                .arc()
                .innerRadius((2 * radius) / 5)
                .outerRadius(radius);

              d3.select(this)
                .text("")
                .attr("transform", d => "translate(" + newarc.centroid(d) + ")")
                .append("tspan")
                .text(id)
                .style("fill", "#000")
                .style("font", "12px")
                .attr("dy", 0)
                .attr("x", 0)
                .attr("text-anchor", "middle")
                .append("tspan")
                .attr("dy", "1.2em")
                .attr("x", 0)
                .attr("text-anchor", "middle")
                .append("tspan")
                .text(perc)
                .attr("dy", "1.2em")
                .attr("x", 0)
                .attr("text-anchor", "middle");
            }
          }
        );
      },
    });

    // When there are many items in legend, the chart gets too small.
    if (resize === true) {
      chart1.resize({ height: 428 });
    }
    this.updateDone = true;
  }

  updateSizePieChart() {
    const self = this;
    let dataArray = [];
    dataArray = this.props.allData.map((data) => {
      return [data.Description, data.Size];
    });

    let singleTheme = true;
    const firstTheme = dataArray[0][0];
    for (let i = 0; i < dataArray.length; i++) {
      if (dataArray[i][0] !== firstTheme) singleTheme = false;
    }

    if (singleTheme) {
      dataArray = this.props.allData.map((data) => {
        if (data.Dataset) {
          return [data.Dataset, data.Size];
        } else if (data.Interface) {
          return [data.Interface, data.Size];
        } else if (data.Description) {
          return [data.Description, data.Size];
        } else {
          return null;
        }
      });
    }

    const resize = dataArray.length > 15;
    const chart2 = c3.generate({
      bindto: "#chartSizeSummaryByTheme",
      data: {
        type: "pie",
        columns: dataArray,
      },
      pie: {
        label: {
          format: function (value, ratio, id) {
            ratio = d3.format("%")(ratio); // format ratio
            if (self.isIE === true) {
              return id;
            } else {
              return [id, ratio].join(); // used to pass values to the onrender function
            }
          },
        },
      },
      onrendered: function () {
        if (window.ActiveXObject || "ActiveXObject" in window) {
          console.log("its IE");
          return;
        }

        d3.selectAll("#chartSizeSummaryByTheme .c3-chart-arc text").each(
          function (v) {
            const label = d3.select(this);
            const data = label._groups[0][0].innerHTML.split(",");

            if (!data[0].toString().includes("<tspan")) {
              const id = data[0];
              const perc = data[1];

              //http://jsfiddle.net/user2314737/kvz8uev8/2/
              const width = 214;
              const radius = width / 2;
              const newarc = d3
                .arc()
                .innerRadius((2 * radius) / 5)
                .outerRadius(radius);

              d3.select(this)
                .text("")
                .attr("transform", d => "translate(" + newarc.centroid(d) + ")")
                .append("tspan")
                .text(id)
                .style("fill", "#000")
                .style("font", "12px")
                .attr("dy", 0)
                .attr("x", 0)
                .attr("text-anchor", "middle")
                .append("tspan")
                .attr("dy", "1.2em")
                .attr("x", 0)
                .attr("text-anchor", "middle")
                .append("tspan")
                .text(perc)
                .attr("dy", "1.2em")
                .attr("x", 0)
                .attr("text-anchor", "middle");
            }
          }
        );
      },
    });

    // When there are many items in legend, the chart gets too small.
    if (resize === true) {
      chart2.resize({ height: 428 });
    }
    this.updateDone = true;
  }

  render() {
    if (this.props.allData.length > 0) {
      this.updateHitsPieChart();
      this.updateSizePieChart();
    } else {
      this.updateDone = false;
    }

    if (this.updateDone === false) return null;

    return (
      <Accordion defaultActiveKey="0" className="mt-4">
        <Card>
          <Card.Header>
            <ContextAwareToggle eventKey="0">Charts</ContextAwareToggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Row>
                <Col md={6} sm={12} xs={12}>
                  <b>Hits</b>
                  <div className="pie1" id="chartHitsSummaryByTheme"></div>
                </Col>
                <Col md={6} sm={12} xs={12}>
                  <b>Size</b>
                  <div id="chartSizeSummaryByTheme"></div>
                </Col>
              </Row>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    );
  }
}

ChartPie.propTypes = {
  allData: PropTypes.array,
};
